import ac_strings from '@/strings/ac_strings.js';
import React from 'react';

import './SigninSignUp.css';

export const Seperator = () => <span className="uppercase text-gray-400 text-xs separator py-2">{ac_strings.or}</span>;
